import { dataAlignRight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAlignRight = /*#__PURE__*/createIcon(dataAlignRight)
export default IconAlignRight
